export const REPORT_CONFIG_GET_REQUEST = 'REPORT_CONFIG_GET_REQUEST';
export const REPORT_CONFIG_GET_SUCCESS = 'REPORT_CONFIG_GET_SUCCESS';
export const REPORT_CONFIG_GET_FAIL = 'REPORT_CONFIG_GET_FAIL';

export const REPORT_CONFIG_UPDATE_REQUEST = 'REPORT_CONFIG_UPDATE_REQUEST';
export const REPORT_CONFIG_UPDATE_SUCCESS = 'REPORT_CONFIG_UPDATE_SUCCESS';
export const REPORT_CONFIG_UPDATE_FAIL = 'REPORT_CONFIG_UPDATE_FAIL';
export const REPORT_CONFIG_UPDATE_RESET = 'REPORT_CONFIG_UPDATE_RESET'; 